<template>
<div id="app">
    <router-view/>
</div>
</template>

<script>
import {
    CONTENT_LOAD_I18N_STRINGS,
    CONTENT_LOAD_VOCABULARY_FORMATS,
    CONTENT_LOAD_VOCABULARY_LANGUAGES
} from "@/store/actions.type";

export default {
    name: 'home',
    components: {

    },
    computed: {

    },
    mounted() {
        this.$store.dispatch(CONTENT_LOAD_I18N_STRINGS);
        this.$store.dispatch(CONTENT_LOAD_VOCABULARY_FORMATS);
        this.$store.dispatch(CONTENT_LOAD_VOCABULARY_LANGUAGES);
    }
}
</script>
